import React, {useMemo} from 'react';

import PropTypes from 'prop-types';
import SwitchSrc from 'react-switch';

import './Switch.scss';

function Switch({onChange, checked, id, disabled, height, width, uncheckedIcon, checkedIcon, onColor, offColor}) {
  const renderUncheckedIcon = useMemo(() => {
    if (uncheckedIcon) return <div className="switch-label-container">{uncheckedIcon}</div>;
    return false;
  }, [uncheckedIcon]);

  const renderCheckedIcon = useMemo(() => {
    if (checkedIcon) return <div className="switch-label-container">{checkedIcon}</div>;
    return false;
  }, [checkedIcon]);

  return (
    <SwitchSrc
      onChange={onChange}
      checked={checked}
      id={id}
      disabled={disabled}
      height={height}
      width={width}
      uncheckedIcon={renderUncheckedIcon}
      checkedIcon={renderCheckedIcon}
      onColor={onColor}
      offColor={offColor}
    />
  );
}

Switch.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  id: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
  uncheckedIcon: PropTypes.bool,
  checkedIcon: PropTypes.bool,
  onColor: PropTypes.string,
  offColor: PropTypes.string,
};

Switch.defaultProps = {
  disabled: false,
  onChange: () => {},
  checked: false,
  id: 'toggle',
  height: 0,
  width: 0,
  uncheckedIcon: false,
  checkedIcon: false,
  onColor: '',
  offColor: '',
};

export default Switch;

export const SWITCH_ID = {
  NORMAL: 'normal-switch',
};
